import { Component, Input, OnInit, output } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { DashboardService } from 'src/app/modules/auth/dashboard/dashboard.service';
import { ReportService } from 'src/app/modules/auth/report/report.service';
import { CoreHelperService } from 'src/app/providers/core-helper/core-helper.service';
import { ReportFilterService } from './report-filter.service';
import { ClaimStatusReportType, ReportsFilterType } from '../../enum/reports-filter-type';
import { UserDomainType } from '../../enum/user-domain';

@Component({
  selector: 'app-report-filter',
  templateUrl: './report-filter.component.html'
})
export class ReportFilterComponent implements OnInit {
  hideDateControl: boolean = true;
  @Input() FacilityDisplay: boolean = false;
  @Input() CarrierDisplay: boolean = false;
  @Input() DateFilter1Display: boolean = false;
  @Input() DateFilter2Display: boolean = false;
  @Input() LOCDisplay: boolean = false;
  @Input() PracticeAddressDisplay: boolean = false;
  @Input() YearDisplay: boolean = false;
  @Input() StatusDisplay: boolean = false;
  @Input() StateDisplay: boolean = false;
  @Input() PrefixDisplay: boolean = false;
  @Input() LabelDateFilter1: string = "";
  @Input() LabelDateFilter2: string = "";
  applyFilterClick = output();
  isFilterSelected: boolean = false;
  // Facility Filter
  originalFacilityList: any[] = [];
  selectFacilityList: any[] = [];
  isCheckedFacility = true;
  // Carrrier Filter
  originalCarrierList: any[] = [];
  selectCarrierList: any[] = [];
  isCheckedCarrier = true;
  // Level Of Care Filter
  originalLOCList: any[] = [];
  selectLOCList: any[] = [];
  isCheckedLOC = true;
  // Practice Address Filter
  originalPracticeAddressList: any[] = [];
  selectPracticeAddressList: any[] = [];
  selectYearList: any[] = [];
  selectStatusList: any[] = [];
  selectStateList: any[] = [];
  selectPrefixList: any[] = [];
  isCheckedPracticeAddress = true;
  showCalenderDateFilter1 = false;

  public filterlistItems: Array<string> = [
    "Today",
    "Custom",
    "This Week",
    "This Month",
    "Last Week",
    "Last Month",
    "This Year",
    "Last Year",
  ];

  isFacilityUser: boolean = false;
  externalUserFacilityName: string = "";

  constructor(public _coreHelperService: CoreHelperService,
    public _dashboardService: DashboardService,
    public _reportService: ReportService,
    public _reportFilterService: ReportFilterService,
  ) {
    let domainId = this._coreHelperService.getUserDomain();
    this.isFacilityUser = (domainId == UserDomainType.External) ? true : false;
    if (this.isFacilityUser) {
      this.externalUserFacilityName = this._coreHelperService.getFacilityName();
      this._reportFilterService.selectedFacility = [{ text: this.externalUserFacilityName, value: this.externalUserFacilityName }];
    }
  }

  async ngOnInit() {
    this.loadDefaultDateRange();
  }

  loadDefaultDateRange() {
    this._reportFilterService.selectedDateFilter1 = "This Month";
    this.showCalenderDateFilter1 = (this._reportFilterService.selectedDateFilter1 === "Custom");
    this._reportFilterService.selectedStartDateFilter1 = this._coreHelperService.getMonthStartDate();
    this._reportFilterService.selectedStartDateFilter2 = this._coreHelperService.getMonthStartDate();
    this._reportFilterService.selectedEndDateFilter1 = this._coreHelperService.getMonthEndDate();
    this._reportFilterService.selectedEndDateFilter2 = this._coreHelperService.getMonthEndDate();
  }

  clearFilter() {
    this.showCalenderDateFilter1 = false;

    this.loadDefaultDateRange();

    this.selectFacilityList = [];
    this.selectFacilityList = this.originalFacilityList;
    this._reportFilterService.selectedFacility = this.selectFacilityList;

    this.selectCarrierList = [];
    this.selectCarrierList = this.originalCarrierList;
    this._reportFilterService.selectedCarrier = this.selectCarrierList;

    this.selectLOCList = [];
    this.selectLOCList = this.originalLOCList;
    this._reportFilterService.selectedLOC = this.selectLOCList;

    this.selectPracticeAddressList = [];
    this.selectPracticeAddressList = this.originalPracticeAddressList;
    this._reportFilterService.selectedPracticeAddress = this.selectPracticeAddressList;

    this._reportFilterService.selectedYear = 2026;
    this._reportFilterService.selectedStatus = null;
    this._reportFilterService.selectedState = null;
    this._reportFilterService.selectedPrefix = null;
  }

  public filterOpen() {
    this.isFilterSelected = false;
  }

  public filterClose() {
    this._reportFilterService.showFilterPopup = false;
  }

  async loadReportFilterData(reportsFilterType: ReportsFilterType = ReportsFilterType.OverviewReport
    , claimStatusReportType: ClaimStatusReportType = ClaimStatusReportType.None) {
    let filterDropdownListRequestModel = {
      FacilityDisplay: this.FacilityDisplay,
      CarrierDisplay: this.CarrierDisplay,
      LOCDisplay: this.LOCDisplay,
      PracticeAddressDisplay: this.PracticeAddressDisplay,
      YearDisplay: this.YearDisplay,
      StatusDisplay: this.StatusDisplay,
      ReportTypeId: reportsFilterType,
      ClaimStatusTypeId: claimStatusReportType,
    }
    await lastValueFrom(this._reportService.getReportFiltersData(filterDropdownListRequestModel)).then((response) => {
      if (response.apiStatus) {
        this.selectFacilityList = [];
        if (this.FacilityDisplay && !this.isFacilityUser) {
          this.selectFacilityList = response.apiData.dropdownListResponseModel1;
          this._reportFilterService.selectedFacility = this.selectFacilityList;
          this.originalFacilityList = response.apiData.dropdownListResponseModel1;

        } else if (this.isFacilityUser) {
          console.log("External Facility name -- ", this.externalUserFacilityName);
          this.selectFacilityList = [{ text: this.externalUserFacilityName, value: this.externalUserFacilityName }];
          this._reportFilterService.selectedFacility = this.selectFacilityList;
          this.originalFacilityList = this.selectFacilityList;
        }

        this.selectCarrierList = [];
        if (this.CarrierDisplay) {
          this.selectCarrierList = response.apiData.dropdownListResponseModel2;
          this._reportFilterService.selectedCarrier = this.selectCarrierList;
          this.originalCarrierList = response.apiData.dropdownListResponseModel2;
        }

        this.selectLOCList = [];
        if (this.LOCDisplay) {
          this.selectLOCList = response.apiData.dropdownListResponseModel3;
          this._reportFilterService.selectedLOC = this.selectLOCList;
          this.originalLOCList = response.apiData.dropdownListResponseModel3;
        }

        this.selectPracticeAddressList = [];
        if (this.PracticeAddressDisplay) {
          this.selectPracticeAddressList = response.apiData.dropdownListResponseModel4;
          this._reportFilterService.selectedPracticeAddress = this.selectPracticeAddressList;
          this.originalPracticeAddressList = response.apiData.dropdownListResponseModel4;
        }

        this.selectYearList = [];
        if (this.YearDisplay) {
          this.selectYearList = response.apiData.dropdownListResponseModel5;
        }

        this.selectStatusList = [];
        if (this.StatusDisplay) {
          this.selectStatusList = response.apiData.dropdownListResponseModel6;
        }

        this.selectStateList = [];
        if (this.StateDisplay) {
          this.selectStateList = response.apiData.dropdownListResponseModel7;
        }

        this.selectPrefixList = [];
        if (this.PrefixDisplay) {
          this.selectPrefixList = response.apiData.dropdownListResponseModel8;
        }

        this.showCalenderDateFilter1 = (this._reportFilterService.selectedDateFilter1 === "Custom");
      }
    });
  }

  //#region Facility Filter
  public get isIndet() {
    return this._reportFilterService.selectedFacility.length !== 0 && this._reportFilterService.selectedFacility.length !== this.selectFacilityList.length;
  }

  public onValueChange() {
    this.isCheckedFacility = this._reportFilterService.selectedFacility.length === this.selectFacilityList.length;
  }

  onFacilityFilterClick(): void {
    this.isCheckedFacility = !this.isCheckedFacility;
    this._reportFilterService.selectedFacility = this.isCheckedFacility ? this.selectFacilityList.slice() : [];
  }

  public get toggleAllText() {
    return this.isCheckedFacility ? 'Deselect All' : 'Select All';
  }

  public isItemSelected(item) {
    return this._reportFilterService.selectedFacility.some((x) => x.text === item.text);
  }
  //#endregion

  //#region Carrier Filter
  public onValueChangeCarrier() {
    this.isCheckedCarrier = this._reportFilterService.selectedCarrier.length === this.selectCarrierList.length;
  }

  public get isIndetCarrier() {
    return this._reportFilterService.selectedCarrier.length !== 0 && this._reportFilterService.selectedCarrier.length !== this.selectCarrierList.length;
  }

  public onClickCarrier() {
    this.isCheckedCarrier = !this.isCheckedCarrier;
    this._reportFilterService.selectedCarrier = this.isCheckedCarrier ? this.selectCarrierList.slice() : [];
  }

  public get toggleAllTextCarrier() {
    return this.isCheckedCarrier ? 'Deselect All' : 'Select All';
  }

  public isItemSelectedCarrier(item) {
    return this._reportFilterService.selectedCarrier.some((x) => x.insuranceCompany === item.insuranceCompany);
  }
  //#endregion

  //#region Level Of Care Filter
  public onValueChangeLOC() {
    this.isCheckedLOC = this._reportFilterService.selectedLOC.length === this.selectLOCList.length;
  }

  public get isIndetLOC() {
    return this._reportFilterService.selectedLOC.length !== 0 && this._reportFilterService.selectedLOC.length !== this.selectLOCList.length;
  }

  public onClickLOC() {
    this.isCheckedLOC = !this.isCheckedLOC;
    this._reportFilterService.selectedLOC = this.isCheckedLOC ? this.selectLOCList.slice() : [];
  }

  public get toggleAllTextLOC() {
    return this.isCheckedLOC ? 'Deselect All' : 'Select All';
  }

  public isItemSelectedLOC(item) {
    return this._reportFilterService.selectedLOC.some((x) => x.locId === item.locId);
  }
  //#endregion

  //#region Practice Address Filter
  public onValueChangePracticeAddress() {
    this.isCheckedPracticeAddress = this._reportFilterService.selectedPracticeAddress.length === this.selectPracticeAddressList.length;
  }

  public get isIndetPracticeAddress() {
    return this._reportFilterService.selectedPracticeAddress.length !== 0 && this._reportFilterService.selectedPracticeAddress.length !== this.selectPracticeAddressList.length;
  }

  public onClickPracticeAddress() {
    this.isCheckedPracticeAddress = !this.isCheckedPracticeAddress;
    this._reportFilterService.selectedPracticeAddress = this.isCheckedPracticeAddress ? this.selectPracticeAddressList.slice() : [];
  }

  public get toggleAllTextPracticeAddress() {
    return this.isCheckedPracticeAddress ? 'Deselect All' : 'Select All';
  }

  public isItemSelectedPracticeAddress(item) {
    return this._reportFilterService.selectedPracticeAddress.some((x) => x.locId === item.locId);
  }
  //#endregion

  getDateFilter1Calculation(event: any) {
    if (event == "Last Year") {
      this.showCalenderDateFilter1 = false;
      this._reportFilterService.selectedStartDateFilter1 = this._coreHelperService.getLastYearStartDate();
      this._reportFilterService.selectedStartDateFilter2 = this._coreHelperService.getLastYearStartDate();
      this._reportFilterService.selectedEndDateFilter1 = this._coreHelperService.getLastYearEndDate();
      this._reportFilterService.selectedEndDateFilter2 = this._coreHelperService.getLastYearEndDate();
    }
    if (event == "Last Week") {
      this.showCalenderDateFilter1 = false;
      this._reportFilterService.selectedStartDateFilter1 = this._coreHelperService.getLastWeekStartDate();
      this._reportFilterService.selectedStartDateFilter2 = this._coreHelperService.getLastWeekStartDate();
      this._reportFilterService.selectedEndDateFilter1 = this._coreHelperService.getLastWeekEndDate();
      this._reportFilterService.selectedEndDateFilter2 = this._coreHelperService.getLastWeekEndDate();
    }
    if (event == "Last Month") {
      this.showCalenderDateFilter1 = false;
      this._reportFilterService.selectedStartDateFilter1 = this._coreHelperService.getLastMonthStartDate();
      this._reportFilterService.selectedStartDateFilter2 = this._coreHelperService.getLastMonthStartDate();
      this._reportFilterService.selectedEndDateFilter1 = this._coreHelperService.getLastMonthEndDate();
      this._reportFilterService.selectedEndDateFilter2 = this._coreHelperService.getLastMonthEndDate();
    }
    if (event == "This Week") {
      this.showCalenderDateFilter1 = false;
      this._reportFilterService.selectedStartDateFilter1 = this._coreHelperService.getWeekStartDate();
      this._reportFilterService.selectedStartDateFilter2 = this._coreHelperService.getWeekStartDate();
      this._reportFilterService.selectedEndDateFilter2 = this._coreHelperService.getWeekEndDate();
    }
    if (event == "This Month") {
      this.showCalenderDateFilter1 = false;
      this._reportFilterService.selectedStartDateFilter1 = this._coreHelperService.getMonthStartDate();
      this._reportFilterService.selectedStartDateFilter2 = this._coreHelperService.getMonthStartDate();
      this._reportFilterService.selectedEndDateFilter1 = this._coreHelperService.getMonthEndDate();
      this._reportFilterService.selectedEndDateFilter2 = this._coreHelperService.getMonthEndDate();
    }
    if (event == "This Year") {
      this.showCalenderDateFilter1 = false;
      this._reportFilterService.selectedStartDateFilter1 = this._coreHelperService.getYearStartDate();
      this._reportFilterService.selectedStartDateFilter2 = this._coreHelperService.getYearStartDate();
      this._reportFilterService.selectedEndDateFilter1 = this._coreHelperService.getYearEndDate();
      this._reportFilterService.selectedEndDateFilter2 = this._coreHelperService.getYearEndDate();
    }
    if (event == "Custom") {
      this.showCalenderDateFilter1 = true;
      this._reportFilterService.selectedStartDateFilter1 = this._coreHelperService.getMonthStartDate();
      this._reportFilterService.selectedStartDateFilter2 = this._coreHelperService.getMonthStartDate();
      this._reportFilterService.selectedEndDateFilter1 = this._coreHelperService.getMonthEndDate();
      this._reportFilterService.selectedEndDateFilter2 = this._coreHelperService.getMonthEndDate();
    }
    if (event == "Today") {
      this.showCalenderDateFilter1 = false;
      this._reportFilterService.selectedStartDateFilter1 = new Date();
      this._reportFilterService.selectedStartDateFilter2 = new Date();
      this._reportFilterService.selectedEndDateFilter1 = new Date();
      this._reportFilterService.selectedEndDateFilter2 = new Date();
    }
  }

  applyFilter() {
    this._reportFilterService.showFilterPopup = false;
    this.applyFilterClick.emit();
  }
}